import React from "react";
import Layout from "../layout/Layout";
import Banner from "../components/technology/Banner";
import IndustryLeaders from "../components/industry-leaders/industry-leaders";
import Intro from "../components/technology/Intro";
import FeaturesList from "../components/technology/FeaturesList";
import Cta from "../components/technology/Cta";
import Testimonials from "../components/technology/Testimonials";

const Technology = () => {
  return (
    <Layout>
      <Banner />
      <IndustryLeaders />
      <Intro />
      <FeaturesList />
      <Cta />
      <Testimonials />
    </Layout>
  );
};

export default Technology;
